import SkTechApiClient from "./base/SkTechApiClient";

export type Country = {
    id: number;
    isoCode: string;
    iso3Code: string;
    name: string;
}

export default class CountryApiClient extends SkTechApiClient {
    public GetAvailableCountries = async (): Promise<Country[]> => {
        return await this.Get(`/api/Country/GetAvailableCountries/`)
            .then((response) => {
                if (response.status === 200) {
                    return response.data;
                }
                throw new Error("Failed to fetch available countries.");
            })
            .catch(function (error) {
                console.error("Error fetching available countries:", error);
                throw error;
            });
    };
}
